import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import './AdminLogin.css';

interface AdminLoginProps {
    isOpen: boolean;
    onClose: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ isOpen, onClose }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { t } = useLanguage();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Will be implemented with backend later
        console.log('Login attempted:', { username, password });
    };

    if (!isOpen) return null;

    return (
        <div className="admin-login-overlay" onClick={onClose}>
            <div className="admin-login-card" onClick={e => e.stopPropagation()}>
                <div className="admin-login-header">
                    <h2>{t('admin.login')}</h2>
                    <button className="close-button" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="admin-login-icon">
                    <LockIcon />
                </div>
                <form onSubmit={handleSubmit} className="admin-login-form">
                    <div className="form-group">
                        <label>{t('admin.username')}</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder={t('admin.username.placeholder')}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('admin.password')}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('admin.password.placeholder')}
                            required
                        />
                    </div>
                    <button type="submit" className="login-button">
                        {t('admin.login.button')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;